import { X } from 'lucide-react';
import { cn } from '@/shared/lib/utils';

const DOT_COLORS = [
  'bg-brand-500',
  'bg-mint-500',
  'bg-amber-500',
  'bg-coral-500',
  'bg-cyan-500',
  'bg-violet-500',
  'bg-rose-500',
  'bg-teal-500',
  'bg-brand-600',
  'bg-emerald-500',
] as const;

function getDotColor(index: number): string {
  return DOT_COLORS[index % DOT_COLORS.length]!;
}

export interface MultiSelectBadgeProps {
  label: string;
  colorIndex: number;
  onRemove: () => void;
  children?: React.ReactNode;
  className?: string;
}

export function MultiSelectBadge({
  label,
  colorIndex,
  onRemove,
  children,
  className,
}: MultiSelectBadgeProps): JSX.Element {
  const dot = getDotColor(colorIndex);

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border border-surface-200 bg-surface-100 pl-2 pr-1 py-1 text-sm font-medium text-ink-800 transition-colors hover:border-surface-300',
        className,
      )}
    >
      <span className={cn('size-2 rounded-full flex-none', dot)} />
      <span className="leading-tight">{label}</span>
      {children && <span className="flex-none">{children}</span>}
      <button
        type="button"
        onClick={onRemove}
        className="flex-none inline-flex items-center justify-center size-4 rounded-full hover:bg-surface-200 transition-colors"
        aria-label={`Remove ${label}`}
      >
        <X className="size-3" />
      </button>
    </span>
  );
}
